import { LEGAL_VERSIONS, missingLegalOperatorFields } from '../../shared/legal';
import type { LegalOperatorConfig } from '../../shared/legal';

export const defaultLegalOperator: LegalOperatorConfig = {
  brandName: 'WALLD Studio',
  legalName: 'Шершнева Александра Витальевна',
  legalForm: 'Физическое лицо, применяющее специальный налоговый режим «Налог на профессиональный доход»',
  country: 'Российская Федерация',
  taxId: '',
  contactEmail: 'walldigitalstudio@gmail.com',
  supportTelegram: '@walldstudio',
  telegramUrl: 'https://t.me/walldstudio',
  address: '',
  privacyContact: 'walldigitalstudio@gmail.com',
  effectiveDate: '2026-09-09',
};

function publicValue(value: string | undefined, fallback: string): string {
  return value?.trim() || fallback;
}

export const legalOperator: LegalOperatorConfig = {
  brandName: publicValue(import.meta.env.VITE_LEGAL_BRAND_NAME, defaultLegalOperator.brandName),
  legalName: publicValue(import.meta.env.VITE_LEGAL_OPERATOR_NAME, defaultLegalOperator.legalName),
  legalForm: publicValue(import.meta.env.VITE_LEGAL_OPERATOR_FORM, defaultLegalOperator.legalForm),
  country: publicValue(import.meta.env.VITE_LEGAL_OPERATOR_COUNTRY, defaultLegalOperator.country),
  taxId: import.meta.env.VITE_LEGAL_OPERATOR_TAX_ID?.trim() || '',
  contactEmail: publicValue(import.meta.env.VITE_LEGAL_CONTACT_EMAIL, defaultLegalOperator.contactEmail),
  supportTelegram: publicValue(import.meta.env.VITE_LEGAL_SUPPORT_TELEGRAM, defaultLegalOperator.supportTelegram),
  telegramUrl: publicValue(import.meta.env.VITE_LEGAL_TELEGRAM_URL, defaultLegalOperator.telegramUrl),
  address: import.meta.env.VITE_LEGAL_OPERATOR_ADDRESS?.trim() || '',
  privacyContact: publicValue(import.meta.env.VITE_LEGAL_PRIVACY_CONTACT, defaultLegalOperator.privacyContact),
  effectiveDate: publicValue(import.meta.env.VITE_LEGAL_EFFECTIVE_DATE, defaultLegalOperator.effectiveDate),
};

export interface LegalConfig {
  privacyVersion: string;
  termsVersion: string;
  consentVersion: string;
  operator: LegalOperatorConfig;
  missingOperatorFields: Array<keyof LegalOperatorConfig>;
  ruDataPlaneReady: boolean;
  readyForPublication: boolean;
}

export function createLegalConfig(operator: LegalOperatorConfig, ruDataPlaneReady: boolean): LegalConfig {
  const missingOperatorFields = missingLegalOperatorFields(operator);
  return {
    ...LEGAL_VERSIONS,
    operator,
    missingOperatorFields,
    ruDataPlaneReady,
    readyForPublication: missingOperatorFields.length === 0 && ruDataPlaneReady,
  };
}

export const legalConfig = createLegalConfig(
  legalOperator,
  import.meta.env.VITE_RU_DATA_PLANE_READY?.trim().toLowerCase() === 'true',
);
